var render = function render(){var _vm=this,_c=_vm._self._c;return _c('other-stock-document-page',{attrs:{"direction":"out"}})
}
var staticRenderFns = []

export { render, staticRenderFns }